import datepickerDEFactory from 'jquery-datepicker/i18n/jquery.ui.datepicker-de';
import datepickerNLFactory from 'jquery-datepicker/i18n/jquery.ui.datepicker-nl';
import datepickerENFactory from 'jquery-datepicker/i18n/jquery.ui.datepicker-en-GB';

const locale = $('html').attr('lang');  // site locale

const dutch = (locale === "nl");
const german = (locale === "de");

const datepickerLocalizerAPI = (!dutch && !german) ? datepickerENFactory : (dutch ? datepickerNLFactory : datepickerDEFactory);
export default datepickerLocalizerAPI;
